module.exports = {
  "country": "LV",
  "artist": "Aminata",
  "song": "Love Injected",
  "year": "2015",
  "place": "6",
  "spotify": "1hWgnVgAhxwP2YDLWeh8xh"
};